module.exports = __webpack_public_path__ + "static/media/light-theme-adblue-low.2bccfae0.svg";